/** Persist the In stock filter across collection and search pages. */
(function () {
  'use strict';

  var STORAGE_KEY = 'tf-instock-filter';
  var PARAM_KEY = STORAGE_KEY + '-param';
  var VALUE_KEY = STORAGE_KEY + '-value';
  var DEFAULT_PARAM = 'filter.v.availability';
  var DEFAULT_VALUE = '1';
  var COOKIE_MAX_AGE = 60 * 60 * 24 * 365;
  var applyingUntil = 0;

  function setPref(on, input) {
    var val = on ? '1' : '0';
    try {
      localStorage.setItem(STORAGE_KEY, val);
      if (input && input.name) {
        localStorage.setItem(PARAM_KEY, input.name);
        localStorage.setItem(VALUE_KEY, input.value || DEFAULT_VALUE);
      }
    } catch (e) {}
    document.cookie = STORAGE_KEY + '=' + val + '; path=/; max-age=' + COOKIE_MAX_AGE + '; SameSite=Lax';
  }

  function getPref() {
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (stored === '1' || stored === '0') return stored;
    } catch (e) {}
    var match = document.cookie.match(/(?:^|;\s*)tf-instock-filter=([^;]*)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function getStoredParam() {
    try {
      return localStorage.getItem(PARAM_KEY) || DEFAULT_PARAM;
    } catch (e) {}
    return DEFAULT_PARAM;
  }

  function getStoredValue() {
    try {
      return localStorage.getItem(VALUE_KEY) || DEFAULT_VALUE;
    } catch (e) {}
    return DEFAULT_VALUE;
  }

  function isApplying() {
    return Date.now() < applyingUntil;
  }

  function markApplying() {
    applyingUntil = Date.now() + 1500;
  }

  function availabilityKeys(params) {
    var keys = [];
    params.forEach(function (_value, key) {
      if (key.indexOf('availability') !== -1) keys.push(key);
    });
    return keys;
  }

  function applyUrl(pref) {
    if (window.Shopify && Shopify.designMode) return false;
    var params = new URLSearchParams(window.location.search);
    var keys = availabilityKeys(params);
    var has = keys.length > 0;
    var wantOn = pref === '1';
    if (wantOn && has) return false;
    if (!wantOn && !has) return false;

    if (wantOn) {
      params.set(getStoredParam(), getStoredValue());
    } else {
      keys.forEach(function (key) {
        params.delete(key);
      });
    }
    params.delete('page');

    var qs = params.toString();
    var next = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    var current = window.location.pathname + window.location.search + window.location.hash;
    if (next === current) return false;
    window.location.replace(next);
    return true;
  }

  function findToggle() {
    return document.querySelector(
      '#mainCollectionProductFiltersForm input[name*="availability"], #mainSearchFiltersForm input[name*="availability"]'
    );
  }

  function applyViaForm(pref) {
    var input = findToggle();
    if (!input || input.disabled) return;
    if (input.checked === (pref === '1')) return;
    markApplying();
    input.click();
  }

  function isInstockInput(input) {
    if (!input || input.type !== 'checkbox') return false;
    if (input.closest('#mainCollectionProductFiltersForm, #mainSearchFiltersForm') == null) return false;
    return !!(input.name && input.name.indexOf('availability') !== -1);
  }

  var pref = getPref();
  if (pref === '1' || pref === '0') {
    if (applyUrl(pref)) return;
  }

  document.addEventListener(
    'change',
    function (e) {
      if (isApplying()) return;
      if (!isInstockInput(e.target)) return;
      setPref(e.target.checked, e.target);
    },
    true
  );

  function onReady() {
    var stored = getPref();
    if (stored !== '1' && stored !== '0') return;

    function run() {
      setTimeout(function () {
        applyViaForm(stored);
      }, 0);
    }

    var tag = document.querySelector('sht-grid-prd-fltr-frm')
      ? 'sht-grid-prd-fltr-frm'
      : document.querySelector('sht-srch-fltr-frm')
        ? 'sht-srch-fltr-frm'
        : '';

    if (tag) {
      if (customElements.get(tag)) run();
      else customElements.whenDefined(tag).then(run);
      return;
    }

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (findToggle() || tries > 40) {
        clearInterval(timer);
        run();
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
